var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v(" DUE DATE OF PAYMENT ")]),_c('h4',[_vm._v(" The fixed date when membership fees must be remitted/paid to HMI to avoid lapsed or inactive membership. ")])])
}]

export { render, staticRenderFns }